// import styles from "./Container.module.css"
function Container ({children}){
    
    
    return (
        <div>
            {children}
        </div>
    );
}

export default Container;